import { getKoreanTime } from "./getKoreanTime";

/**
 * DatePicker에 전달할 날짜를 한국 시간 기준으로 변환하여 ISO 문자열로 반환
 * 어느 나라에서 접근하더라도 한국 시간 기준으로 표시되도록 처리
 *
 * @param date - 변환할 날짜 (Date 객체, 문자열, 또는 null)
 * @returns 한국 시간 기준 ISO 문자열 또는 null
 */
export function toKoreanISOString(date: Date | string | null): string | null {
  if (!date) return null;

  try {
    const dateObj = typeof date === "string" ? new Date(date) : date;
    return getKoreanTime(dateObj).toISOString();
  } catch (error) {
    console.warn("Invalid date provided to toKoreanISOString:", date);
    return null;
  }
}

/**
 * DatePicker용 날짜 범위 객체를 한국 시간 기준으로 변환
 *
 * @param dateRange - 변환할 날짜 범위 객체
 * @returns 한국 시간 기준으로 변환된 날짜 범위 객체
 */
export function convertDateRangeToKoreanISO<
  T extends Record<string, Date | string | null>,
>(dateRange: T): Record<keyof T, string | null> {
  const result = {} as Record<keyof T, string | null>;

  Object.entries(dateRange).forEach(([key, value]) => {
    result[key as keyof T] = toKoreanISOString(value);
  });

  return result;
}

/**
 * checkIn, checkOut 형태의 날짜 범위를 DatePicker용으로 변환하는 헬퍼 함수
 *
 * @param checkIn - 체크인 날짜
 * @param checkOut - 체크아웃 날짜
 * @returns DatePicker에 전달할 수 있는 형태의 객체
 */
export function formatDateRangeForPicker(
  checkIn: Date | string | null,
  checkOut: Date | string | null,
) {
  return {
    checkIn: toKoreanISOString(checkIn),
    checkOut: toKoreanISOString(checkOut),
  };
}
